// API helpers for the Bulk Email Sender (Phase 19).
function backendBase() {
  return process.env.REACT_APP_BACKEND_URL || '';
}

function authHeader() {
  const token = localStorage.getItem('healthcues_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function jsonOrThrow(response) {
  let body = null;
  try { body = await response.json(); } catch (_) { /* no-op */ }
  if (!response.ok) {
    const detail = body && body.detail;
    if (detail && typeof detail === 'object') {
      const err = new Error(detail.message || 'Request failed');
      err.providerError = detail.providerError;
      err.auditId = detail.auditId;
      err.status = response.status;
      throw err;
    }
    const err = new Error((body && body.detail) || `Request failed (${response.status})`);
    err.status = response.status;
    throw err;
  }
  return body;
}

export async function listRecipients({ audience, clientId } = {}) {
  const params = new URLSearchParams();
  params.set('audience', audience);
  if (clientId) params.set('clientId', clientId);
  const url = `${backendBase()}/api/communications/recipients?${params.toString()}`;
  const res = await fetch(url, { headers: { ...authHeader() } });
  return jsonOrThrow(res);
}

export async function bulkSend(payload) {
  const res = await fetch(`${backendBase()}/api/communications/bulk-send`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(payload),
  });
  return jsonOrThrow(res);
}

export async function listBulkHistory(limit = 100) {
  const res = await fetch(`${backendBase()}/api/communications/bulk-history?limit=${limit}`, {
    headers: { ...authHeader() },
  });
  return jsonOrThrow(res);
}

export async function getBulkHistoryDetail(id) {
  const res = await fetch(`${backendBase()}/api/communications/bulk-history/${encodeURIComponent(id)}`, {
    headers: { ...authHeader() },
  });
  return jsonOrThrow(res);
}

export const BULK_AUDIENCES = [
  { value: 'account_manager', label: 'Account Managers',  icon: 'people-outline'   },
  { value: 'employer',        label: 'Employer Contacts', icon: 'business-outline' },
  { value: 'employee',        label: 'Employees',         icon: 'person-outline'   },
];

export function audienceLabel(v) {
  return (BULK_AUDIENCES.find((a) => a.value === v) || { label: v }).label;
}
